import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import Loading from "../../../components/Loading";
import { useClaims } from "../../../auth/ClaimsProvider";
import { AppendIfPrefixExists } from "../../../modules/sitePaths";

const EMPTY_TENANT_ID = "00000000-0000-0000-0000-000000000000";

export function hasTenantId(tenantId: string | undefined): boolean {
  return !!tenantId && tenantId !== EMPTY_TENANT_ID;
}

interface TenantRouteGuardProps {
  children: ReactNode;
}

export default function TenantRouteGuard({
  children,
}: TenantRouteGuardProps) {
  const { claimsLoading, getClaimValue } = useClaims();

  if (claimsLoading) {
    return <Loading />;
  }

  if (!hasTenantId(getClaimValue("tenantId"))) {
    return <Navigate to={AppendIfPrefixExists("/home")} replace />;
  }

  return <>{children}</>;
}
